import React, {useState} from 'react'

import Box from '@material-ui/core/Box'

import {ButtonBlock, TextBlock, Content} from '../../styles'
import {Buttons, ButtonBack, ButtonPrimary, ButtonSecondary} from '../../ui-kit/Button'
import Animate from '../../ui-kit/Animate'

import {OptionsSelector} from '../../components'

var Question = ({input, answersInput, onBack, onChange, loading, onNext}) => {

	const [canSubmit, setCanSubmit] = useState(null)

  const question = "12. Quão empolgado você está para começar?"
	var answers

	if (input.user.gender == "m") {
		answers = [
			{id: 1, type: 'default', value: "Estou só curioso para saber. Não pretendo começar agora"},
			{id: 2, type: 'default', value: "Quero começar agora, nem que seja de leve e depois que me motivar com resultados ir acelerando"},
			{id: 3, type: 'default', value: "Quero integrar isso de leve e constante de um jeito que eu conseguiria seguir por 10 anos+ (a base padrão Fit n Livin')"},
			{id: 4, type: 'default', value: "Estou bem empolgado. Quero fazer alguns meses mais rápido e depois encontrar um padrão tranquilo que eu consiga manter por 10 anos+"},
			{id: 5, type: 'default', value: "Realmente, essa é a coisa mais importante para mim agora. Esse é meu objetivo primário. Posso até por outras coisas de lado para priorizar resultados rápidos agora. Quero fazer um progresso gigante em 3 meses"},
		]
	} else {
		answers = [
			{id: 1, type: 'default', value: "Estou só curiosa para saber. Não pretendo começar agora"},
			{id: 2, type: 'default', value: "Quero começar agora, nem que seja de leve e depois que me motivar com resultados ir acelerando"},
			{id: 3, type: 'default', value: "Quero integrar isso de leve e constante de um jeito que eu conseguiria seguir por 10 anos+ (a base padrão Fit n Livin')"},
			{id: 4, type: 'default', value: "Estou super empolgada. Quero fazer alguns meses mais rápido e depois encontrar um padrão tranquilo que eu consiga manter por 10 anos+"},
			{id: 5, type: 'default', value: "Realmente, essa é a coisa mais importante para mim agora. Esse é meu objetivo primário. Posso até por outras coisas de lado para priorizar resultados rápidos agora. Quero fazer um progresso gigante em 3 meses"},
		]
	}

	return (
		<Content>
			<TextBlock>
				<form onSubmit={onNext}>
					<Animate duration="1s" delay=".3s">
						<Box fontSize={22} fontWeight={900} lineHeight={1.1} mb={2}>
							{question}
						</Box>
					</Animate>

					<Animate duration="1s" delay="2s">
						<OptionsSelector
              type="radio"
              delay={2}
              position={0}
              onChange={onChange}
              question={question}
              answers={answers}
              answersInput={answersInput}
              onValid={(valid) => setCanSubmit(valid)}
            />
					</Animate>

					<Animate duration="1s" delay="4s">
						<ButtonBlock>
							<Buttons>
								<ButtonBack onClick={onBack}>
									Voltar
								</ButtonBack>
								{canSubmit
									? (
										loading
										? (
											<ButtonPrimary type="button">
												Enviando...
											</ButtonPrimary>
										)
										: (
											<ButtonPrimary type="submit">
												Próximo →
											</ButtonPrimary>
										)
									)
									: (
										<ButtonSecondary type="button">
											Próximo
										</ButtonSecondary>
									)
								}
							</Buttons>
						</ButtonBlock>
					</Animate>
				</form>
			</TextBlock>
		</Content>
	)
}

export default Question